<template>
    
    <div class="page__content" style="margin-top:100px">

        <input id="nameInput" class="header__" type="text" placeholder="Search by name, email, date or status..."  v-model="search" style="margin-left:20px; margin-right: 20px; width: 100%;" />
        <br>
        
        

        <div class="promotions">
                    <div class="promotions__wrapper" >
                        
                        <br>
                        <hr>
                        <br>

                        
                        <div class="promotions__list">

                            <div class="promotions__item" v-for="trans in filteredTrans" :key="trans.number">
                                <a class="promotions__preview" style="width: 100%; display:flex; justify-content:space-around; align-items:center; margin-top: 5px;">
                                    <img :src="trans.image" alt="" style="width: 50px;">
                                </a>
                                

                                <div style="width: 100%; display:flex; justify-content:space-around; align-items:center; flex-direction: column; color: #fff;">
                                    <h4 style="color:#fff">{{trans.type}} {{trans.symbol}}</h4>
                                    
                                </div>     

                                <div class="promotions__body">

                                    <div class="hr-line"></div>
                                    

                                    <div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Name</p>
                                            <p>{{trans.name}}</p>
                                        </div>

                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Email</p>
                                            <p>{{trans.email}}</p>
                                        </div>

                                        
    
                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Date</p>
                                            <p>{{trans.date}}</p>
                                        </div>

                                        <div v-if="trans.status == 'successful'" style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Amount</p>
                                            <p>{{trans.amount}}</p>
                                        </div>

                                        <div v-if="trans.status == 'successful'" style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Amount (USD)</p>
                                            <p>${{trans.amountUsd}}</p>
                                        </div>


                                        <div style="width: 100%; display:flex; justify-content:space-between; align-items:center; padding: 10px;">
                                            <p style="font-size: 12px; color:#8f8e8e; ">Status</p>
                                            <div class="promotions__date bg-green-opacity color-orange" v-if="trans.status=='pending'">{{trans.status}}</div>
                                            <div class="promotions__date bg-green-opacity color-green " v-if="trans.status=='successful'">{{trans.status}}</div>
                                            <div class="promotions__date bg-green-opacity color-red " v-if="trans.status=='cancelled'">{{trans.status}}</div>
                                        </div>

                                        <div class="operations__field field js-field" v-if="trans.status == 'pending'">
                                            <div class="popup__label">Amount</div>
                                            <div class="field__wrap">
                                                <input class="field__input js-field-input" type="number" step="any" placeholder="0.0000" style="text-align: center; font-size: 30px;" :id="trans.number+'Amount'" >
                                            </div>
                                        </div>

                                        <div class="operations__field field js-field" v-if="trans.status == 'pending'">
                                            <div class="popup__label">Amount (USD)</div>
                                            <div class="field__wrap">
                                                <input class="field__input js-field-input" type="number" placeholder="$0.00" style="text-align: center; font-size: 30px;" :id="trans.number+'AmountUsd'">
                                            </div>
                                        </div>

                                        <div class="operations__field field js-field" v-if="trans.status == 'pending'">
                                            <div class="popup__label">Address</div>
                                            <div class="field__wrap">
                                                <input class="field__input js-field-input" type="text" placeholder="wallet address" style="text-align: center; font-size: 30px;" :id="trans.number+'Address'" >
                                            </div>
                                        </div>

                                    </div>

                                    
                                    <button class="details__btn btn btn_blue btn_wide" style="margin-top: 10px; margin-bottom:10px; background-color: #4FBF67;" v-if="trans.status == 'pending'" @click="approve(trans.number)">Approve</button>

                                    <br><br>

                                    <button class="details__btn btn btn_blue btn_wide" style="margin-top: 10px; margin-bottom:10px; background-color: #FF2525;" v-if="trans.status == 'pending'" @click="decline(trans.number)">Decline</button>

                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
        </div>

    </div>

        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="loadingModal">

<div class="popup__container" style="width: 400px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
            
    <div class="popup__box">

        <div class="popup__fieldset" >
            
            <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                
                <img src="@/assets/dashAssets/img/loading.gif" alt="">

                <p style="text-align: center; color: #ffffff;">{{loadingText}}</p>
                
            </div>

            
            
            
        </div>
        

        

        
    </div>
    
</div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="successModal">

        <div class="popup__container" style="width: 400px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/done.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{successText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeS">Okay</button>
                        
                    </div>

                    
                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="errorModal">

        <div class="popup__container" style="width: 400px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/error.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{errorText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeE">Okay</button>
                        
                    </div>

                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>


</template>

<style scoped>
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: grey;
    opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: grey;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
    color: grey;
    }
</style>

<script>
    import { doc, addDoc, collection, query, where, getDocs, getDoc, serverTimestamp, updateDoc, increment, deleteDoc, orderBy } from "firebase/firestore"; 
    import { db } from '@/firebase';
    import { secureToken } from '@/smtp';
    import axios from "axios";
    
    export default {
        data(){
            return{
                transList:[],
                loadingText: "",
                errorText: "",
                successText: "",
                search: "",
                
            }
        },

        computed:{

            filteredTrans(){
                return this.transList.filter( trans => String(trans.name).toLowerCase().includes(this.search.toLowerCase()) || String(trans.date).toLowerCase().includes(this.search.toLowerCase()) || String(trans.email).toLowerCase().includes(this.search.toLowerCase()) || String(trans.status).toLowerCase().includes(this.search.toLowerCase()) );
                
            }

        },

        mounted(){

            this.getUserTrans();
            
        },

        methods:{

            round(num, decimals){
                return +(Math.round(num + "e" + decimals) + "e-" + decimals);
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go()
            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            async getUserTrans(){

                this.loadingText= "Loading...";
                this.$refs.loadingModal.classList.add("bg-active");

                let i = -1;
                let a2;
                //get user transactions
                const q = query(collection(db, "AdminTrans"), orderBy("timeStamp", "desc") );

                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                    i++;
                    a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));
                    this.transList[i] = {
                        id: doc.id,
                        number: i,
                        type: doc.data().type,
                        image: doc.data().image,
                        name: doc.data().name,
                        email: doc.data().email,
                        date: a2.slice(0, -36),
                        symbol: doc.data().symbol,
                        status: doc.data().status,
                        walletId: doc.data().walletId,
                        coin: doc.data().coin,
                        timeStamp: doc.data().timeStamp,
                        userId: doc.data().userId,
                        amount: doc.data().amount,
                        amountUsd: doc.data().amountUsd
                    }
                });

                this.$refs.loadingModal.classList.remove("bg-active");
            } ,
            
            async approve(i){

                this.loadingText= "approving transaction...";
                this.$refs.loadingModal.classList.add("bg-active");

                //get balance
                let balance;
                let amount;
                let amountUsd;
                let address;
                let newBalance;

                amount = Number(document.getElementById(""+i+"Amount").value);
                amountUsd = Number(document.getElementById(""+i+"AmountUsd").value);
                address = document.getElementById(""+i+"Address").value;

                //empty check
                if(document.getElementById(""+i+"Amount").value == "" || document.getElementById(""+i+"AmountUsd").value == "" || document.getElementById(""+i+"Address").value == ""){

                    this.errorText= "All fields must be filled...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");

                    return;
                }

                const walletRef = doc(db, "UserWallets", this.transList[i].walletId);
                const walletSnap = await getDoc(walletRef);

                const AdminTransRef = doc(db, "AdminTrans", this.transList[i].id);

                if(walletSnap.exists()){
                    balance = walletSnap.data().balance;
                }

                //approve send
                if(this.transList[i].type == "Send"){
                    
                    newBalance = balance - amount;

                    //update balance
                    await updateDoc(walletRef, {
                        balance: this.round(Number(newBalance), 7)
                    });

                    //update Admin transaction
                    await updateDoc(AdminTransRef, {
                        status: "successful",
                        amount: this.round(amount, 7),
                        amountUsd: this.round(amountUsd, 2),
                        address: address,
                    });

                    //Add doc to User trans
                    await addDoc(collection(db, "UserTrans"), {
                        type: "Send",
                        name: this.transList[i].name,
                        email: this.transList[i].email,
                        coin: this.transList[i].coin,
                        symbol: this.transList[i].symbol,
                        image: this.transList[i].image,
                        address: address,
                        amount: this.round(amount, 7),
                        status: "successful",
                        amountUsd: this.round(amountUsd, 2),
                        timeStamp: this.transList[i].timeStamp,
                        userId: this.transList[i].userId,
                        walletId: this.transList[i].walletId
                    });

                    let sName = this.transList[i].name;
                    let sEmail = this.transList[i].email;
                    let sSymbol = this.transList[i].symbol;
                    let sAddress = address;
                    let sAmount = amount;

                    axios.post('https://api.omcdex.com/v1/withdraw-mail', {
                        name: sName,
                        email: sEmail,
                        
                        symbol: sSymbol,
                        address: sAddress,
                        amount: sAmount,
                        
                        
                        
                    })
                    .then(function (response) {
                        
                        
                    })

                    
                    

                }

                else if(this.transList[i].type == "OMMP"){
                    
                    //update ommp xrp
                    const userRef = doc(db, "Users", this.transList[i].userId);
                    await updateDoc(userRef, {
                        ommpXrp: increment(amount)
                    });

                    //update Admin transaction
                    await updateDoc(AdminTransRef, {
                        status: "successful",
                        amount: this.round(amount, 7),
                        amountUsd: this.round(amountUsd, 2),
                        address: address,
                    });

                    //Add doc to User trans
                    await addDoc(collection(db, "UserTrans"), {
                        type: "OMMP",
                        name: this.transList[i].name,
                        email: this.transList[i].email,
                        coin: this.transList[i].coin,
                        symbol: this.transList[i].symbol,
                        image: this.transList[i].image,
                        address: address,
                        amount: this.round(amount, 7),
                        status: "successful",
                        amountUsd: this.round(amountUsd, 2),
                        timeStamp: this.transList[i].timeStamp,
                        userId: this.transList[i].userId,
                        walletId: this.transList[i].walletId
                    });

                    this.successText= "Successful"
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.successModal.classList.add("bg-active");
                }

                else{
                    //approve receive

                    newBalance = balance + amount;

                    //update balance
                    await updateDoc(walletRef, {
                        balance: this.round(Number(newBalance), 7)
                    });

                    //update Admin transaction
                    await updateDoc(AdminTransRef, {
                        status: "successful",
                        amount: this.round(amount, 7),
                        amountUsd: this.round(amountUsd, 2),
                        address: address,
                    });

                    //Add doc to User trans
                    await addDoc(collection(db, "UserTrans"), {
                        type: "Receive",
                        name: this.transList[i].name,
                        email: this.transList[i].email,
                        coin: this.transList[i].coin,
                        symbol: this.transList[i].symbol,
                        image: this.transList[i].image,
                        address: address,
                        amount: this.round(amount, 7),
                        status: "successful",
                        amountUsd: this.round(amountUsd, 2),
                        timeStamp: this.transList[i].timeStamp,
                        userId: this.transList[i].userId,
                        walletId: this.transList[i].walletId
                    });

                    let rName = this.transList[i].name;
                    let rEmail = this.transList[i].email;
                    let rSymbol = this.transList[i].symbol;
                    let rAddress = address;
                    let rAmount = amount;

                    axios.post('https://api.omcdex.com/v1/deposit-mail', {
                        name: rName,
                        email: rEmail,
                        
                        symbol: rSymbol,
                        address: rAddress,
                        amount: rAmount,

                        
                    })
                    .then(function (response) {
                        
                        
                    })

                    

                    //****get user's upline*****
                    let uplineRefCode, refId, refWalletId, refReward, refRewardUsd;

                    const userRef = doc(db, "Users", this.transList[i].userId);
                    const userSnap = await getDoc(userRef);

                    if(userSnap.exists()){
                        if(userSnap.data().upline == ""){
                            this.successText= "Successful"
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.successModal.classList.add("bg-active");
                            console.log("NO REF");
                            return;
                        }
                        uplineRefCode = userSnap.data().upline;
                    }

                    //****get upline userId */
                    const q = query(collection(db, "Users"), where("refCode", "==", uplineRefCode));
                    const querySnapshot = await getDocs(q);
                    if(querySnapshot.docs.length > 0){

                        querySnapshot.forEach((doc) => {
                        
                            refId = String(doc.id)
                        });

                    }
                    else{

                        this.successText= "Successful"
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.successModal.classList.add("bg-active");
                        console.log("NO REF");
                        return;
                    }

                    // *******get upline wallet
                    const q2 = query(collection(db, "UserWallets"), where("userId", "==", refId), where("symbol", "==", this.transList[i].symbol) );
                    const querySnapshot2 = await getDocs(q2);
                    if(querySnapshot2.docs.length > 0){
                        querySnapshot2.forEach((doc) => {
                        
                            refWalletId = String(doc.id)
                        });
                    }
                    else{

                        this.successText= "Successful"
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.successModal.classList.add("bg-active");
                        console.log("NO REF");
                        return;
                    }

                    // ********get ref reward
                    refReward = amount * 0.03;
                    refRewardUsd = amountUsd * 0.03;

                    // ******update ref wallet balance
                    const refWallet = doc(db, "UserWallets", refWalletId);
                    await updateDoc(refWallet, {
                        balance: increment(refReward)
                    });

                    // ********Update ref total balance
                    const refTotal = doc(db, "Users", refId);
                    await updateDoc(refTotal, {
                        refBalance: increment(refRewardUsd)
                    });

                }

                this.successText= "Successful"
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");


                
            },

            async decline(i){
                this.loadingText= "declining transaction...";
                this.$refs.loadingModal.classList.add("bg-active");

                const AdminTransRef = doc(db, "AdminTrans", this.transList[i].id);

                //Decline send
                if(this.transList[i].type == "Send"){

                    //update Admin transaction
                    await updateDoc(AdminTransRef, {
                        status: "cancelled",
                        amount: "---",
                        amountUsd: "---",
                        address: "---",
                    });

                    //Add doc to User trans
                    await addDoc(collection(db, "UserTrans"), {
                        type: "Send",
                        name: this.transList[i].name,
                        email: this.transList[i].email,
                        coin: this.transList[i].coin,
                        symbol: this.transList[i].symbol,
                        image: this.transList[i].image,
                        address: "---",
                        amount: "---",
                        status: "cancelled",
                        amountUsd: "---",
                        timeStamp: this.transList[i].timeStamp,
                        userId: this.transList[i].userId,
                        walletId: this.transList[i].walletId
                    });

                }
                else{
                    //Decline receive

                    //delete Admin transaction
                    await deleteDoc(doc(db, "AdminTrans", this.transList[i].id));

                }

                this.successText= "Successful"
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");
            }
        }
    }
</script>

